import ChapterList from './ChapterList'

const ChapterBox = () => {
  return (
    <div>
      <ChapterList />
    </div>
  )
}

export default ChapterBox
